<template>
  <div id="app">
    <!-- 修改密码 -->
    <el-dialog
      :visible.sync="visible"
      title="修改密码"
      width="800px"
      :lock-scroll="true"
      :center="true"
    >
      <el-form ref="passform" :model="passform" label-width="120px">
        <el-form-item
          label="原始密码"
          prop="oldPassword"
          :rules="[
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model="passform.oldPassword"
            type="password"
          />
        </el-form-item>
        <el-form-item
          prop="newPassword"
          label="新密码"
          :rules="[
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model="passform.newPassword"
            type="password"
          />
        </el-form-item>
        <el-form-item
          label="确认新密码"
          prop="newPassword1"
          :rules="[
            {
              validator: checkPassword,
              required: true,
              trigger: 'blur',
            },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model="passform.newPassword1"
            type="password"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelpass">取消</el-button>
        <el-button size="small" type="primary" @click="submitpass"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-popover ref="popover" placement="bottom" width="200" trigger="hover">
      <div class="popovername" v-if="roleType == 'teacher' ? true : false">
        <span v-if="roleType == 'teacher' ? true : false">
          <el-image
            class="imglogo"
            style="float: left"
            :src="hostUrl + userDatas.headPhotoUrl"
            fit="cover"
          >
            <div slot="error" class="image-slot">
              <i
                ><img
                  style="height: 40px"
                  v-if="userDatas.sex == 1"
                  src="../../assets/img/sex0.png"
              /></i>
              <i
                ><img
                  style="height: 40px"
                  v-if="userDatas.sex == 0"
                  src="../../assets/img/默认头像.png"
              /></i>
               <i
                  ><img
                    style="height: 40px"
                    v-if="userDatas.sex == null"
                    src="../../assets/img/默认头像.png"
                    alt=""
                    srcset=""
                /></i></div
          ></el-image>
        </span>
        <div v-if="roleType == 'teacher' ? true : false" class="usernames">
          {{ userDatas.name }}
        </div>
      </div>
      <el-divider v-if="roleType == 'teacher' ? true : false"></el-divider>
      <ul class="header_right_se">
        <li
          v-if="roleType == 'teacher' ? true : false"
          @click="$router.push('/teacherbasic')"
        >
          个人资料
        </li>
        <li @click="xgpassword">修改密码</li>
        <li class="unLogin" @click="unLogin">退出登录</li>
      </ul>
    </el-popover>
    <el-container>
      <!-- 头部区域 -->
      <el-header class="header">
        <!-- 头部左侧区域 -->
        <div class="header_text">
          <div class="herder_text_left">基础数据管理</div>
          <el-menu
            v-for="(item, index) in onePermissionsMenu"
            :key="index"
            mode="horizontal"
            router
            :default-active="'/' + activePath"
          >
            <el-menu-item
              :index="'/' + item.html"
              @click="setItemPath(item.html)"
              >{{ item.name }}</el-menu-item
            >
          </el-menu>
        </div>
        <!-- 头部右侧区域 -->
        <div class="header_right">
          <div class="header_btny">
            <add-bookss
              v-show="roleType == 'teacher' ? true : false"
              class="header_btny"
            ></add-bookss>
          </div>
          <ul>
            <!-- <li @click="$router.push('/bench?token=' + token)" style="cursor: pointer">
              工作台
            </li> -->
            <li @click="workTai" style="cursor: pointer">工作台</li>
          </ul>

          <div class="hearder_right_user" v-popover:popover>
            <span v-if="roleType == 'teacher' ? true : false">
              <el-image
                class="imglogo"
                :src="hostUrl + userDatas.headPhotoUrl"
                fit="cover"
              >
                <div slot="error" class="image-slot">
                  <i
                    ><img
                      style="height: 40px"
                      v-if="userDatas.sex == 1"
                      src="../../assets/img/sex0.png"
                  /></i>
                  <i
                    ><img
                      style="height: 40px"
                      v-if="userDatas.sex == 0"
                      src="../../assets/img/默认头像.png"
                  />
                   <i
                  ><img
                    style="height: 40px"
                    v-if="userDatas.sex == null"
                    src="../../assets/img/默认头像.png"
                    alt=""
                    srcset=""
                /></i></i>
                </div>
              </el-image>
            </span>
            <div class="username" v-if="roleType == 'teacher' ? false : true">
              {{ userDatas.name }}
            </div>
          </div>
        </div>
      </el-header>
      <!-- 内容主体区域 -->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import addBookss from '../bench/components/addbook'
import {
  userpermissionsall,
  UserLogout,
  usercenterinfo,
  modifyPassWord,
  roleByUser,
  userpermissions,
  homeUrl
} from '@/api/home'
export default {
  components: {
    addBookss,
  },
  data() {
    return {
      // 一级权限菜单
      
      url:homeUrl, //统一跳转前置路径
      onePermissionsMenu: [],
      userData: [],
      schoolId: 0,
      userDatas: [],
      visible: false,
      roleType: '',
      appName: '',
      // roleTypes: localStorage.getItem('roleTypes'),
      // 处理默认高亮
      activePath: '',
      passform: {
        oldPassword: '',
        newPassword: '',
        newPassword1: '',
      },
      times: '',
      token: '',
      classesVo: [],
      roleByUsers: [],
      roleId: '',
    }
  },
  watch: {},
  created() {
    this.token = this.$route.query.token
    this.roleId = this.$route.query.roleId
    if (this.token !== 'undefined' && this.token) {
      localStorage.setItem('token', this.token)
    }
    if (this.roleId !== 'undefined' && this.roleId) {
      localStorage.setItem('roleId', this.roleId)
    }
    this.roleId = localStorage.getItem('roleId')
    this.usercenterinfo()
    this.setItemPath()
    this.userpermissions()
    // 初始化时取出保存的页面路径
  },
  methods: {
    //   获取当前用户登陆信息
    async usercenterinfo() {
      const { data: res } = await usercenterinfo()
      this.userData = res.data
      this.hostUrl = res.data.hostUrl
      localStorage.setItem('type',res.data.schoolType)
      if (res.data.roleType == 'teacher') {
        this.userDatas = res.data.teacher
        this.roleType = res.data.roleType
        localStorage.setItem('schoolIds', res.data.teacher.schoolId)
        localStorage.setItem('roleType', res.data.roleType)
        localStorage.setItem('userId', res.data.teacher.id)
        if (res.data.teacher.classesVo && this.roleId == '-1003') {
          localStorage.setItem('classId', res.data.teacher.classesVo.id)
          localStorage.setItem('gradeId', res.data.teacher.classesVo.gradeId)
          this.$router.push('/school/classes?token=' + this.$route.query.token)
        }
        this.classesVo = res.data.teacher.classesVo
        this.roleByUser()
      } else if (res.data.roleType == 'school') {
        this.roleType = res.data.roleType
        localStorage.setItem('schoolIds', res.data.school.id)
        localStorage.setItem('userId', res.data.school.id)
        localStorage.setItem('roleType', res.data.roleType)
        this.userDatas = res.data.school
      }

    },
    //根据角色查询权限菜单
    async userpermissions() {
      const { data: res } = await userpermissions({
        roleId: this.roleId,
      })
      this.onePermissionsMenu = res.data
    },
    // // 调用用户权限接口
    // async userpermissionsall() {
    //   const { data: res } = await userpermissionsall({
    //     appCode: 'JCSJGL',
    //     parentId: 0,
    //   })
    //   this.onePermissionsMenu = res.data
    // },
    // 获取自己全部角色
    async roleByUser() {
      const { data: res } = await roleByUser()
      this.roleByUsers = res.data
      if (!this.classesVo && this.roleByUsers.length == 1) {
        this.$message.error('您没有进入权限哦，请联系管理员！！！')
        setTimeout(() => {
          let urlss =
            this.url + 'bench?token=' +
            localStorage.getItem('token')
          window.open(urlss, '_self')
        }, 500)
      }
    },

    // 处理默认高亮
    setItemPath(activePath) {
      const path = this.$route.path
      if (path == '/notice') {
        this.$router.push('/notice')
        this.activePath = 'notice'
        return false
      }
      this.activePath = 'basicmanager'
    },

    // 退出登陆
    async unLogin() {
      const confirResult = await this.$confirm('您确定要退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch((err) => err)
      if (confirResult !== 'confirm') {
        return this.$message.info('已取消！！')
      }
      const res = await UserLogout()
      localStorage.clear()
      sessionStorage.clear()
      // this.$router.push('/user/login')
      // let urls = this.url + 'user/login'
      let urls = this.url
      // let urls = this.url
      window.open(urls, '_self')
    },

    // 修改密码
    xgpassword() {
      this.visible = true
    },
    cancelpass() {
      this.visible = false
      this.resetForm('passform')
    },
    resetForm(form) {
      this.$refs[form].resetFields()
    },
    workTai() {
      // let urlss =
      //   this.url + 'schoolhome?token=' +
      //   localStorage.getItem('token')
      // window.open(urlss, '_self')
      let urlss =
        this.url + 'bench?token=' +
        localStorage.getItem('token')
      window.open(urlss, '_self')
    },

    checkPassword(rule, value, callback) {
      if (!value) {
        return callback(new Error('二次密码不能为空'))
      } else {
        if (this.passform.newPassword !== this.passform.newPassword1) {
          return callback(new Error('两次密码必须输入一致'))
        } else {
          callback()
        }
      }
    },
    submitpass() {
      this.$refs.passform.validate((valid) => {
        if (valid) {
          this.ApiModifyPassByOld()
        } else {
          this.$message.error('请检查信息是否填写正确')
          return false
        }
      })
    },
    ApiModifyPassByOld() {
      const { passform } = this
      modifyPassWord({ ...passform }).then((res) => {
        this.$message.success('修改成功,下次登录请使用先密码登录')
        this.visible = false
        this.resetForm('passform')
      })
    },
    // 处理路由刷新跳转
    toRouter() {
      // const path = this.$router.path
      // if (path == '/notice') {
      //   this.$router.push('/notice')
      //   this.activePath = 'notice'
      //   return false
      // }
      // this.activePath = 'basicmanager'
    },
  },

  computed: {},
  mounted() {},
}
</script>
<style scoped>
#app {
  background-color: #f7f7f7;
  margin: 0;
  padding: 0;
  height: 100%;
}
.el-container {
  height: 100vh;
}
.el-header {
  height: 80px;
  margin-bottom: 16px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}
.header_text {
  width: 905px;
  display: flex;
  justify-content: left;
  padding: 0 40px;
}
.herder_text_left {
  margin-right: 360px;
  font-size: 20px;
}
.el-menu {
  margin-left: 40px;
}
.el-aside {
  background-color: #fff;
  margin-left: 0 20px;
}
.el-main {
  margin: 0 20px;
  background-color: #f7f7f7;
}

/* 头部左侧区域 */
.herder_text_left {
  font-size: 20px;
  line-height: 60px;
}

.herder_text_right ul {
  width: 180px;
  display: flex;
  justify-content: space-between;
  line-height: 60px;
}

.herder_text_right li {
  list-style: none;
  display: inline-block;
  font-size: 14px;
}

/* 头部右侧区域 */
.header_right {
  display: flex;
}

.header_right ul {
  display: flex;
  justify-content: space-between;
}

.header_right li {
  line-height: 60px;
  list-style: none;
  font-size: 14px;
  display: inline-block;
}

.header_right_se li {
  list-style: none;
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  margin-bottom: 10px;
}

.hearder_right_user {
  cursor: pointer;
  float: right;
  margin: 10px 30px 0px;
}

.imglogo {
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 50%;
}
.username {
  float: right;
  font-size: 14px;
  margin-top: 10px;
  margin-left: 15px;
}
.header_right_se li {
  cursor: pointer;
  list-style: none;
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
}
.header_right_se li:hover {
  background-color: #e1efff;
}
.header_btny {
  float: left;
  /* margin-top: 6px;
  margin-right: 15px; */
  margin: 6px 15px 0 0;
}
/* 头部结束 */

/* 侧边栏 */
.el-menu-item span {
  display: inline-block;
  width: 200px;
  text-align: center;
  font-size: 14px;
}
.usernames {
  float: left;
  display: inline-block;
  width: 60px;
  font-size: 14px;
  /* margin-top: 10px; */
  margin-left: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.popovername {
  height: 40px;
  line-height: 40px;
  padding: 0 32px;
}
.el-divider {
  margin: 10px 0;
}
.unLogin{
  background-color: #409eff;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/basisdata/basis.vue